// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-4c230298] .custom-input textarea.form-control{height:96px}[data-v-4c230298] .radio-button-row .radio-button{text-align:center;flex:1 1 auto;max-width:50%}.badge-primary[data-v-4c230298]{text-transform:capitalize}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
